import {
  Box,
  Button,
  HStack,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react'
import { Formik } from 'formik'
import React from 'react'
import { useEffect } from 'react'
import { useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { REPOSITORY } from '../../api/repository/Repository'
import InputForm from '../../components/InputForm/InputForm'
import SelectorField from '../../components/Selector/SelectorField'
import UnderlineHeading from '../../components/UnderlineText/UnderlineHeading'
import { contactTypes } from '../../utils/constants'
import { useLoadingContext } from '../../utils/hooks/Context/LoadingContext'
import { colors } from '../../utils/theme/styles'
import ConfirmModal from './ConfirmModal'
import { useRequestStatusContext } from './../../utils/hooks/Context/RequestStatusContext'
import { emailValidation } from '../../utils/formats/validators'

export default function ContactDetail() {
  const params = useParams()
  const navigate = useNavigate()
  const [data, setData] = useState()
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [isEdit, setIsEdit] = useState(false)

  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()
  const handleFetch = async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.employees.getContacts(params.id).then((res) => {
      if (res.data.length > 0) {
        setData(res.data[0])
      }
      handleCLoseLoading()
    })
  }

  const editContact = async (data) => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.employees
      .editManager(data)
      .then((response) => {
        handleCLoseLoading()
        onClose()
        if (response.status === 200) {
          handleSetTitle('Información actualizada correctamente', response.status)
          handleChangeBody(null)
          handleOpen()
          setTimeout(() => {
            handleClose()
            navigate(-1)
          }, 2000)
        } else {
          handleSetTitle(
            'Hubo un problema al actualizar la información',
            response.status,
          )
          handleChangeBody(
            <Button variant="primary" onClick={handleClose}>
              Contactar a soporte ahora
            </Button>,
          )
          handleOpen()
        }
      })
      .catch((error) => {
        handleCLoseLoading()
        onClose()
        handleSetTitle(
          'Hubo un problema al actualizar la información',
          error.response.status,
        )
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.response.status === 200
              ? 'Continuar'
              : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
  }

  const handleEditing = () => {
    setIsEdit((prevState) => !prevState)
  }
  useEffect(() => {
    handleFetch()
  }, [])

  return (
    <>
      <VStack alignItems="flex-start" h="100%">
        <UnderlineHeading text="Información del interlocutor" variant={'h5'} />
        <Formik
          enableReinitialize
          initialValues={{ ...data }}
          validateOnBlur
          validateOnMount
          validateOnChange
          onSubmit={async (values) => {
            await editContact(values)
            handleEditing()
          }}
          validate={(values) => {
            const error = {}
            if (!values.sNombreContacto || values.sNombreContacto === '') {
              error.sNombreContacto = 'Requerido'
            }
            if (!values.sApellidoPaterno) {
              error.sApellidoPaterno = 'Requerido'
            }
            if (!values.sTelefonoFijo && !values.sTelefonoMovil) {
              error.sTelefonoMovil =
                'Debe ingresar al menos un número telefonico'
              error.sTelefonoFijo =
                'Debe ingresar al menos un número telefonico'
            }
            if (!values.sApellidoMaterno) {
              error.sApellidoMaterno = 'Requerido'
            }
            const emailError = emailValidation(values.sEmailContacto)
            if (emailError) {
              error.sEmailContacto = emailError
            }
            return error
          }}
        >
          {({ values, errors, handleSubmit, handleChange, isValid }) => (
            <VStack alignItems="flex-start" w="100%" spacing="30px">
              <ConfirmModal
                isOpen={isOpen}
                onContinue={handleSubmit}
                onClose={onClose}
              />
              <HStack
                mt="30px"
                w="100%"
                wrap="wrap"
                alignItems="start"
                gap="24px"
                spacing={0}
              >
                <VStack
                  w="40%"
                  alignItems="flex-start"
                  spacing="30px"
                  minW="400px"
                  mr="16px"
                >
                  <SelectorField
                    name="sTipoContacto"
                    options={contactTypes}
                    boxShadow={
                      isEdit &&
                      '0px 0px 0px 2px #D6ECFF, inset 0px 0px 0px 1px #6C8EEF'
                    }
                    value={values?.sTipoContacto}
                    onChange={handleChange}
                    title={'Tipo de contacto'}
                    isClearable
                    isDisabled={!isEdit}
                    titleType="subtitle3"
                    placeholder="Seleccione un tipo de contacto"
                  />
                  <VStack alignItems="flex-start" w="100%">
                    <InputForm
                      disabled={!isEdit}
                      boxShadow={
                        isEdit &&
                        '0px 0px 0px 2px #D6ECFF, inset 0px 0px 0px 1px #6C8EEF'
                      }
                      border={!isEdit && '1px solid #E3E8EE'}
                      variant="subtitle3"
                      stackProps={{ w: '100%' }}
                      name="sNombreContacto"
                      id="sNombreContacto"
                      _disabled={{ opacity: '0.7', cursor: 'not-allowed' }}
                      title="Nombre"
                      // disabled={!isEdit}
                      onChange={handleChange}
                      value={values?.sNombreContacto || ''}
                    />
                    {errors.sNombreContacto && (
                      <Box>
                        <Text color={colors.log.error} variant="body3">
                          {errors.sNombreContacto}
                        </Text>
                      </Box>
                    )}
                  </VStack>
                  <VStack alignItems="flex-start" w="100%">
                    <InputForm
                      disabled={!isEdit}
                      variant="subtitle3"
                      stackProps={{ w: '100%' }}
                      name="sApellidoPaterno"
                      color="black"
                      _disabled={{ opacity: '0.7', cursor: 'not-allowed' }}
                      id="sApellidoPaterno"
                      title="Primer Apellido"
                      boxShadow={
                        isEdit &&
                        '0px 0px 0px 2px #D6ECFF, inset 0px 0px 0px 1px #6C8EEF'
                      }
                      onChange={handleChange}
                      value={values?.sApellidoPaterno || ''}
                    />
                    {errors.sApellidoPaterno && (
                      <Box>
                        <Text color={colors.log.error} variant="body3">
                          {errors.sApellidoPaterno}
                        </Text>
                      </Box>
                    )}
                  </VStack>
                  <VStack alignItems="flex-start" w="100%">
                    <InputForm
                      disabled={!isEdit}
                      variant="subtitle3"
                      stackProps={{ w: '100%' }}
                      name="sApellidoMaterno"
                      _disabled={{ opacity: '0.7', cursor: 'not-allowed' }}
                      boxShadow={
                        isEdit &&
                        '0px 0px 0px 2px #D6ECFF, inset 0px 0px 0px 1px #6C8EEF'
                      }
                      id="sApellidoMaterno"
                      title="Segundo Apellido"
                      onChange={handleChange}
                      value={values?.sApellidoMaterno || ''}
                    />
                    {errors.sApellidoMaterno && (
                      <Box>
                        <Text color={colors.log.error} variant="body3">
                          {errors.sApellidoMaterno}
                        </Text>
                      </Box>
                    )}
                  </VStack>
                  <VStack alignItems="flex-start" w="100%">
                    <InputForm
                      disabled={!isEdit}
                      variant="subtitle3"
                      stackProps={{ w: '100%' }}
                      _disabled={{ opacity: '0.7', cursor: 'not-allowed' }}
                      name="sRut"
                      id="sRut"
                      boxShadow={
                        isEdit &&
                        '0px 0px 0px 2px #D6ECFF, inset 0px 0px 0px 1px #6C8EEF'
                      }
                      title="Rut"
                      onChange={handleChange}
                      value={values?.sRut || ''}
                    />
                    {errors.sRut && (
                      <Box>
                        <Text color={colors.log.error} variant="body3">
                          {errors.sRut}
                        </Text>
                      </Box>
                    )}
                  </VStack>
                </VStack>
                <VStack
                  w="40%"
                  alignItems="flex-start"
                  spacing="30px"
                  minW="400px"
                  mr="16px"
                >
                  <Box w="100%">
                    <InputForm
                      disabled={!isEdit}
                      variant="subtitle3"
                      _disabled={{ opacity: '0.7', cursor: 'not-allowed' }}
                      name="sCargo"
                      boxShadow={
                        isEdit &&
                        '0px 0px 0px 2px #D6ECFF, inset 0px 0px 0px 1px #6C8EEF'
                      }
                      id="sCargo"
                      title="Cargo"
                      onChange={handleChange}
                      value={values?.sCargo || ''}
                    />
                  </Box>

                  <VStack alignItems="flex-start" w="100%">
                    <Box w="100%">
                      <InputForm
                        disabled={!isEdit}
                        variant="subtitle3"
                        name="sTelefonoFijo"
                        id="sTelefonoFijo"
                        _disabled={{ opacity: '0.7', cursor: 'not-allowed' }}
                        boxShadow={
                          isEdit &&
                          '0px 0px 0px 2px #D6ECFF, inset 0px 0px 0px 1px #6C8EEF'
                        }
                        title="Telefono Fijo"
                        onChange={handleChange}
                        value={values?.sTelefonoFijo || ''}
                      />
                    </Box>
                    {errors.sTelefonoFijo && (
                      <Box>
                        <Text color={colors.log.error} variant="body3">
                          {errors.sTelefonoFijo}
                        </Text>
                      </Box>
                    )}
                  </VStack>

                  <VStack alignItems="flex-start" w="100%">
                    <Box w="100%">
                      <InputForm
                        disabled={!isEdit}
                        variant="subtitle3"
                        _disabled={{ opacity: '0.7', cursor: 'not-allowed' }}
                        name="sTelefonoMovil"
                        id="sTelefonoMovil"
                        boxShadow={
                          isEdit &&
                          '0px 0px 0px 2px #D6ECFF, inset 0px 0px 0px 1px #6C8EEF'
                        }
                        title="Telefono celular"
                        onChange={handleChange}
                        value={values?.sTelefonoMovil || ''}
                      />
                    </Box>
                    {errors.sTelefonoMovil && (
                      <Box>
                        <Text color={colors.log.error} variant="body3">
                          {errors.sTelefonoMovil}
                        </Text>
                      </Box>
                    )}
                  </VStack>
                  <VStack alignItems="flex-start" w="100%">
                    <InputForm
                      disabled={!isEdit}
                      stackProps={{ w: '100%' }}
                      name="sEmailContacto"
                      _disabled={{ opacity: '0.7', cursor: 'not-allowed' }}
                      id="sEmailContacto"
                      boxShadow={
                        isEdit &&
                        '0px 0px 0px 2px #D6ECFF, inset 0px 0px 0px 1px #6C8EEF'
                      }
                      variant="subtitle3"
                      title="Correo asociado a la cuenta del interlocutor"
                      onChange={handleChange}
                      value={values?.sEmailContacto || ''}
                    />
                    {errors.sEmailContacto && (
                      <Box>
                        <Text color={colors.log.error} variant="body3">
                          {errors.sEmailContacto}
                        </Text>
                      </Box>
                    )}
                  </VStack>
                </VStack>
              </HStack>
              <Button
                mb="200px"
                w="40%"
                h="66px"
                borderRadius="8px"
                disabled={!isValid && isEdit}
                variant={isEdit ? 'secondary' : 'primary'}
                onClick={!isEdit ? handleEditing : onOpen}
              >
                {isEdit
                  ? 'Actualizar información de Interlocutor'
                  : 'Editar datos'}
              </Button>
            </VStack>
          )}
        </Formik>
      </VStack>
    </>
  )
}
